import styled from 'styled-components';

export const FieldMessages = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding-bottom: 0.5rem;
`;

export default FieldMessages;
